import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fighters
export const getFighters = () => axios.get(`${API}/fighters`);
export const getFighter = (id) => axios.get(`${API}/fighters/${id}`);
export const createFighter = (data) => axios.post(`${API}/fighters`, data);
export const updateFighter = (id, data) => axios.put(`${API}/fighters/${id}`, data);
export const deleteFighter = (id) => axios.delete(`${API}/fighters/${id}`);

// Training Camps
export const getTrainingCamps = (fighterId = null) => {
  const params = fighterId ? `?fighter_id=${fighterId}` : '';
  return axios.get(`${API}/training-camps${params}`);
};
export const getTrainingCamp = (id) => axios.get(`${API}/training-camps/${id}`);
export const createTrainingCamp = (data) => axios.post(`${API}/training-camps`, data);
export const updateTrainingCamp = (id, data) => axios.put(`${API}/training-camps/${id}`, data);
export const deleteTrainingCamp = (id) => axios.delete(`${API}/training-camps/${id}`);

// Assessments
export const getAssessments = (fighterId = null) => {
  const params = fighterId ? `?fighter_id=${fighterId}` : '';
  return axios.get(`${API}/assessments${params}`);
};
export const getAssessment = (id) => axios.get(`${API}/assessments/${id}`);
export const createAssessment = (data) => axios.post(`${API}/assessments`, data);
export const updateAssessment = (id, data) => axios.put(`${API}/assessments/${id}`, data);
export const deleteAssessment = (id) => axios.delete(`${API}/assessments/${id}`);

// Fights
export const getFights = (fighterId = null) => {
  const params = fighterId ? `?fighter_id=${fighterId}` : '';
  return axios.get(`${API}/fights${params}`);
};
export const getFight = (id) => axios.get(`${API}/fights/${id}`);
export const createFight = (data) => axios.post(`${API}/fights`, data);
export const updateFight = (id, data) => axios.put(`${API}/fights/${id}`, data);
export const deleteFight = (id) => axios.delete(`${API}/fights/${id}`);

// Coaches
export const getCoaches = () => axios.get(`${API}/coaches`);
export const createCoach = (data) => axios.post(`${API}/coaches`, data);
export const deleteCoach = (id) => axios.delete(`${API}/coaches/${id}`);
export const updateCoachPermissions = (id, permissions) => 
  axios.put(`${API}/coaches/${id}/permissions`, permissions);

// Account Management
export const changePassword = (data) => axios.post(`${API}/auth/change-password`, data);
export const updateProfile = (data) => axios.put(`${API}/auth/profile`, data);
export const getProfile = () => axios.get(`${API}/auth/profile`);

// Dashboard
export const getDashboardStats = () => axios.get(`${API}/dashboard/stats`);

// Subscription
export const getSubscriptionTiers = () => axios.get(`${API}/subscription/tiers`);
export const createCheckout = (tier, originUrl) => 
  axios.post(`${API}/subscription/checkout`, { tier, origin_url: originUrl });
export const getCheckoutStatus = (sessionId) => 
  axios.get(`${API}/subscription/status/${sessionId}`);
export const getSubscriptionHistory = () => axios.get(`${API}/subscription/history`);
export const getCurrentSubscription = () => axios.get(`${API}/subscription/current`);
export const cancelSubscription = () => axios.post(`${API}/subscription/cancel`);

// Gym
export const getGym = () => axios.get(`${API}/gym`);
export const updateGym = (data) => axios.put(`${API}/gym`, data);
export const getGymSportConfig = () => axios.get(`${API}/gym/sport-config`);
export const getSubscriptionTiersList = () => axios.get(`${API}/subscription-tiers`);

// Videos
export const getVideos = (fighterId = null) => {
  const params = fighterId ? `?fighter_id=${fighterId}` : '';
  return axios.get(`${API}/videos${params}`);
};
export const getVideoUploadUrl = (data) => axios.post(`${API}/videos/presigned-url`, data);

// Weight Tracking
export const getWeightEntries = (fighterId = null) => {
  const params = fighterId ? `?fighter_id=${fighterId}` : '';
  return axios.get(`${API}/weight-entries${params}`);
};
export const createWeightEntry = (data) => axios.post(`${API}/weight-entries`, data);
export const deleteWeightEntry = (id) => axios.delete(`${API}/weight-entries/${id}`);

// Weight Goals
export const getWeightGoal = (fighterId) => axios.get(`${API}/weight-goals/${fighterId}`);
export const createWeightGoal = (data) => axios.post(`${API}/weight-goals`, data);
export const deleteWeightGoal = (fighterId) => axios.delete(`${API}/weight-goals/${fighterId}`);

// Members & Attendance
export const getMembers = () => axios.get(`${API}/members`);
export const createMember = (data) => axios.post(`${API}/members`, data);
export const deleteMember = (id) => axios.delete(`${API}/members/${id}`);

export const getClasses = () => axios.get(`${API}/classes`);
export const createClass = (data) => axios.post(`${API}/classes`, data);
export const deleteClass = (id) => axios.delete(`${API}/classes/${id}`);

export const checkInMember = (data) => axios.post(`${API}/attendance/check-in`, data);
export const getAttendance = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return axios.get(`${API}/attendance${queryString ? `?${queryString}` : ''}`);
};
export const getAttendanceStats = () => axios.get(`${API}/attendance/stats`);

// Trial Status
export const getTrialStatus = () => axios.get(`${API}/gym/trial-status`);

// Analytics
export const trackFeatureUsage = (feature, action, metadata = {}) => 
  axios.post(`${API}/analytics/track`, { feature, action, metadata });

// Fighter Comparison
export const compareFighters = (fighter1Id, fighter2Id) => 
  axios.get(`${API}/fighters/compare/${fighter1Id}/${fighter2Id}`);

// Email Notifications
export const sendEmailNotification = (data) => 
  axios.post(`${API}/notifications/send-email`, data);
export const sendToCoaches = (subject, notificationType, content) => 
  axios.post(`${API}/notifications/send-to-coaches?subject=${encodeURIComponent(subject)}&notification_type=${notificationType}`, content);
export const getNotificationHistory = () => 
  axios.get(`${API}/notifications/history`);

// PDF Reports
export const getFighterPDF = (fighterId) => 
  `${API}/reports/fighter/${fighterId}/pdf`;
export const getGymOverviewPDF = () => 
  `${API}/reports/gym/pdf`;
export const getAttendancePDF = (startDate, endDate) => 
  `${API}/reports/attendance/pdf?start_date=${startDate}&end_date=${endDate}`;
export const getCampPDF = (campId) => 
  `${API}/reports/camp/${campId}/pdf`;

// CSV Exports
export const exportFightersCSV = () => `${API}/export/fighters/csv`;
export const exportAssessmentsCSV = () => `${API}/export/assessments/csv`;
export const exportAttendanceCSV = (startDate, endDate) => 
  `${API}/export/attendance/csv${startDate || endDate ? `?start_date=${startDate}&end_date=${endDate}` : ''}`;
export const exportFightsCSV = () => `${API}/export/fights/csv`;
export const exportCampsCSV = () => `${API}/export/training-camps/csv`;
export const exportWeightCSV = () => `${API}/export/weight-entries/csv`;
export const exportMembersCSV = () => `${API}/export/members/csv`;

// Membership Plans
export const getMembershipPlans = () => axios.get(`${API}/membership-plans`);
export const getMembershipPlan = (id) => axios.get(`${API}/membership-plans/${id}`);
export const createMembershipPlan = (data) => axios.post(`${API}/membership-plans`, data);
export const updateMembershipPlan = (id, data) => axios.put(`${API}/membership-plans/${id}`, data);
export const deleteMembershipPlan = (id) => axios.delete(`${API}/membership-plans/${id}`);
export const getMembershipStats = () => axios.get(`${API}/membership-stats`);

// Member Subscriptions
export const getMemberSubscriptions = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return axios.get(`${API}/member-subscriptions${queryString ? `?${queryString}` : ''}`);
};
export const getMemberSubscription = (id) => axios.get(`${API}/member-subscriptions/${id}`);
export const createMemberSubscriptionCheckout = (data) => 
  axios.post(`${API}/member-subscriptions/checkout`, data);
export const getMemberSubscriptionStatus = (sessionId) => 
  axios.get(`${API}/member-subscriptions/status/${sessionId}`);
export const cancelMemberSubscription = (id) => 
  axios.post(`${API}/member-subscriptions/${id}/cancel`);

// Fighter Portal
export const registerFighter = (data) => axios.post(`${API}/fighter/register`, data);
export const getFighterDashboard = () => axios.get(`${API}/fighter/dashboard`);
export const updateFighterProfile = (data) => axios.put(`${API}/fighter/profile`, data);
export const getFighterSubscriptionStatus = () => axios.get(`${API}/fighter/subscription/status`);
export const createFighterSubscriptionCheckout = () => axios.post(`${API}/fighter/subscription/checkout`);

// Fighter Notes
export const createFighterNote = (data) => axios.post(`${API}/fighter/notes`, data);
export const getFighterNotes = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return axios.get(`${API}/fighter/notes${queryString ? `?${queryString}` : ''}`);
};

// Fighter Training Logs
export const createTrainingLog = (data) => axios.post(`${API}/fighter/training-logs`, data);
export const getTrainingLogs = (limit = 30) => axios.get(`${API}/fighter/training-logs?limit=${limit}`);
export const deleteTrainingLog = (id) => axios.delete(`${API}/fighter/training-logs/${id}`);

// Gym Join Requests (Fighter)
export const requestToJoinGym = (data) => axios.post(`${API}/fighter/gym-request`, data);
export const getFighterGymRequests = () => axios.get(`${API}/fighter/gym-requests`);
export const searchGyms = (query = '') => axios.get(`${API}/gyms/search?q=${encodeURIComponent(query)}`);

// Gym Join Requests (Admin)
export const getGymJoinRequests = () => axios.get(`${API}/gym/join-requests`);
export const approveJoinRequest = (id) => axios.post(`${API}/gym/join-requests/${id}/approve`);
export const rejectJoinRequest = (id) => axios.post(`${API}/gym/join-requests/${id}/reject`);

// Fighter Invites (Admin)
export const createFighterInvite = (data) => axios.post(`${API}/gym/fighter-invites`, data);
export const getFighterInvites = () => axios.get(`${API}/gym/fighter-invites`);
export const deleteFighterInvite = (id) => axios.delete(`${API}/gym/fighter-invites/${id}`);

// Fighter History (Coach view with portable data)
export const getFighterHistory = (fighterId) => axios.get(`${API}/fighters/${fighterId}/history`);
export const getFighterGymHistory = (fighterId) => axios.get(`${API}/fighters/${fighterId}/gym-history`);

// Fighter Gym History (Self)
export const getMyGymHistory = () => axios.get(`${API}/fighter/gym-history`);

// Fight Week
export const getFightWeekData = () => axios.get(`${API}/fighter/fight-week`);
export const logFightWeekWeighIn = (data) => axios.post(`${API}/fighter/fight-week/weigh-in`, data);
export const updateFightWeekChecklist = (fightId, items) => axios.put(`${API}/fighter/fight-week/checklist/${fightId}`, { items });

// Post-Fight Analysis
export const getFightAnalysis = (fightId) => axios.get(`${API}/fights/${fightId}/analysis`);
export const submitFighterAnalysis = (fightId, data) => axios.post(`${API}/fights/${fightId}/fighter-analysis`, data);
export const submitCoachAnalysis = (fightId, data) => axios.post(`${API}/fights/${fightId}/coach-analysis`, data);
export const getCompletedFights = () => axios.get(`${API}/fighter/completed-fights`);

// Camp Goals
export const getCampGoals = (campId) => axios.get(`${API}/training-camps/${campId}/goals`);
export const createCampGoal = (campId, data) => axios.post(`${API}/training-camps/${campId}/goals`, data);
export const updateCampGoal = (campId, goalId, data) => axios.put(`${API}/training-camps/${campId}/goals/${goalId}`, data);
export const deleteCampGoal = (campId, goalId) => axios.delete(`${API}/training-camps/${campId}/goals/${goalId}`);
export const getFighterCampGoals = () => axios.get(`${API}/fighter/camp-goals`);

// Push Notifications
export const getVapidPublicKey = () => axios.get(`${API}/push/vapid-public-key`);
export const subscribeToPush = (subscription) => axios.post(`${API}/push/subscribe`, { subscription });
export const unsubscribeFromPush = (endpoint) => axios.delete(`${API}/push/unsubscribe?endpoint=${encodeURIComponent(endpoint)}`);
